module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/lines/wall/textures/painted-normal.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/lines/wall/textures/painted-normal.png
// module id = 468
// module chunks = 0